export default {
  fetching: true,
  loading: true,

  userFieldsResponse: {},
  userFieldsFailResponse: {},
};
